FizConfig.termsURL = FizConfig.termsURL || "terms.html";
FizConfig.faqURL = FizConfig.faqURL || "faq.html";

FizConfig.defaultColor =  "#4784EC";
  
//defaultLocation
FizConfig.defaultLocation = {latitude:48.85,longitude:2.33,zoom:4};

FizConfig.invitequota = 200;

FizConfig.noWeb = false;

if(!window.fetch){
  FizConfig.GIPHY_API_KEY = undefined;
}

export default FizConfig;